import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': '简体中文',
  'smarthr-ui/ActionDialog/closeButtonLabel': '取消',
  'smarthr-ui/AppHeader/school': 'SmartHR 学堂',
  'smarthr-ui/AppHeader/help': '帮助',
  'smarthr-ui/AppHeader/userSettings': '个人设置',
  'smarthr-ui/AppHeader/releaseNotes': '版本说明',
  'smarthr-ui/AppHeader/releaseNotesLoadError': '版本更新说明读取失败。\n请稍后重新尝试。',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': '查看所有版本说明',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': '应用',
  'smarthr-ui/AppHeader/MobileHeader/account': '账号',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': '打开菜单',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': '关闭菜单',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': '所有应用',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': '管理菜单',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': '最新版本说明',
  'smarthr-ui/AppHeader/MobileHeader/back': '返回',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': '展开',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': '关闭',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': '请输入应用名称。',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': '常用应用',
  'smarthr-ui/AppHeader/Launcher/allModeText': '所有应用',
  'smarthr-ui/AppHeader/Launcher/listText': '应用列表',
  'smarthr-ui/AppHeader/Launcher/helpText': '关于常用应用',
  'smarthr-ui/AppHeader/Launcher/searchResultText': '搜索结果',
  'smarthr-ui/AppHeader/Launcher/emptyText': '未找到匹配的应用。',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': '显示排序',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': '已选择',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': '默认',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': '以应用名称升序',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': '以应用名称降序',
  'smarthr-ui/AppLauncher/showAllText': '查看全部',
  'smarthr-ui/AppLauncher/triggerLabel': '应用',
  'smarthr-ui/Browser/notFoundDescription': '请尝试其他条件。',
  'smarthr-ui/Browser/notFoundTitle': '暂无符合条件的项目。',
  'smarthr-ui/Button/loading': '处理中',
  'smarthr-ui/Calendar/currentYear': '当前年份',
  'smarthr-ui/Calendar/nextMonth': '下一月',
  'smarthr-ui/Calendar/previousMonth': '上一月',
  'smarthr-ui/Calendar/selectYear': '选择年份',
  'smarthr-ui/Combobox/addItemButtonLabel': '添加“{name}”',
  'smarthr-ui/Combobox/loadingText': '处理中',
  'smarthr-ui/Combobox/noResultsText': '暂无符合条件的选项。',
  'smarthr-ui/DropdownMenuButton/triggerActive': '收起选项',
  'smarthr-ui/DropdownMenuButton/triggerInactive': '展开选项',
  'smarthr-ui/DropZone/selectButtonLabel': '选择文件',
  'smarthr-ui/FileViewer/rotateAlt': '左转',
  'smarthr-ui/FileViewer/scaleDownAlt': '缩小',
  'smarthr-ui/FileViewer/scaleRateLabel': '放大率（%）',
  'smarthr-ui/FileViewer/scaleUpAlt': '放大',
  'smarthr-ui/FileViewer/unsupportedFileText': '不支持的文件格式。',
  'smarthr-ui/FilterDropdown/applyText': '启用',
  'smarthr-ui/FilterDropdown/cancelText': '取消',
  'smarthr-ui/FilterDropdown/resetText': '解除筛选条件',
  'smarthr-ui/FilterDropdown/status': '已启用',
  'smarthr-ui/FilterDropdown/triggerText': '筛选',
  'smarthr-ui/FormDialog/closeButtonLabel': '取消',
  'smarthr-ui/InformationPanel/closeButtonLabel': '关闭',
  'smarthr-ui/InformationPanel/openButtonLabel': '展开',
  'smarthr-ui/InputFile/destroy': '删除',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': '已选择',
  'smarthr-ui/Loader/alt': '处理中',
  'smarthr-ui/MessageDialog/closeButtonLabel': '关闭',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': '关闭',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': '对话框的位置',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': '可拖动',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': '按方向键可上下左右移动',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '上边距 {top} px，左边距 {left} px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': '：删除',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': '已选项目',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': '关闭',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': '移至开头',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': '移至末尾',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': '下一步',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': '上一步',
  'smarthr-ui/Pagination/itemButtonLabel': '第 {page} 页',
  'smarthr-ui/Pagination/navigationLabel': '分页',
  'smarthr-ui/RequiredLabel/text': '必填',
  'smarthr-ui/SearchInput/iconAlt': '搜索',
  'smarthr-ui/SideMenu/navigationLabel': '侧边菜单',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': '清除',
  'smarthr-ui/SortDropdown/applyText': '启用',
  'smarthr-ui/SortDropdown/ascLabel': '升序',
  'smarthr-ui/SortDropdown/cancelText': '取消',
  'smarthr-ui/SortDropdown/descLabel': '降序',
  'smarthr-ui/SortDropdown/sortFieldLabel': '排序项目',
  'smarthr-ui/SortDropdown/sortOrderLegend': '排列顺序',
  'smarthr-ui/StepFormDialog/backButtonLabel': '返回',
  'smarthr-ui/StepFormDialog/closeButtonLabel': '取消',
  'smarthr-ui/StepFormDialog/nextButtonLabel': '下一步',
  'smarthr-ui/StepStatusIcon/closedAlt': '中断',
  'smarthr-ui/StepStatusIcon/completedAlt': '已完成',
  'smarthr-ui/Textarea/availableLetters': '还可输入 {availableLetters} 个字符',
  'smarthr-ui/Textarea/maxLettersExceeded': '超出 {exceededLetters} 个字符',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': '最多可输入 {maxLetters} 个字符',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': '在新标签页中打开',
  'smarthr-ui/Th/sortDirectionAsc': '升序',
  'smarthr-ui/Th/sortDirectionDesc': '降序',
  'smarthr-ui/Th/sortDirectionNone': '无排序',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': '选择/取消所有项目',
  'smarthr-ui/ThCheckbox/checkColumnName': '选择',
} as const satisfies Record<keyof typeof ja, string>
